import React, { useEffect, createElement } from 'react';
type PixelFunction = ((...args: unknown[]) => void) & {
  queue?: unknown[][];
  loaded?: boolean;
  version?: string;
};
declare global {
  interface Window {
    fbq?: PixelFunction;
    _fbq?: PixelFunction;
    mateFacilPixelInitialized?: boolean;
  }
}
const pixelId = '931401796468747';
export function MetaPixel() {
  useEffect(() => {
    if (window.mateFacilPixelInitialized) return;
    const fbq = window.fbq ?? function (...args: unknown[]) {
      fbq.queue?.push(args);
    } as PixelFunction;
    fbq.queue = fbq.queue ?? [];
    fbq.loaded = true;
    fbq.version = '2.0';
    window.fbq = fbq;
    window._fbq = fbq;
    window.mateFacilPixelInitialized = true;
    if (!document.querySelector('script[data-meta-pixel="mate-facil"]')) {
      const script = document.createElement('script');
      script.async = true;
      script.src = 'https://connect.facebook.net/en_US/fbevents.js';
      script.setAttribute('data-meta-pixel', 'mate-facil');
      document.head.appendChild(script);
    }
    fbq('init', pixelId);
    fbq('track', 'PageView');
  }, []);
  return null;
}